import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';
import StepOne from './steps/StepOne';
import StepTwo from './steps/StepTwo';
import StepThree from './steps/StepThree';
import { selectRegistrationCurrentStep } from '../../../../store/selectors';

const propTypes = {
  currentStep: PropTypes.oneOf([0, 1, 2]).isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string,
    inner: PropTypes.string,
  }).isRequired,
};

export const ActionsRow = props => {
  const { currentStep, classes } = props;

  switch (currentStep) {
    case 0:
      return (
        <div className={classes.root}>
          <div className={classes.inner}>
            <StepOne />
          </div>
        </div>
      );
    case 1:
      return (
        <div className={classes.root}>
          <div className={classes.inner}>
            <StepTwo />
          </div>
        </div>
      );
    case 2:
    default:
      return (
        <div className={classes.rootDark}>
          <div className={classes.innerCenter}>
            <StepThree />
          </div>
        </div>
      );
  }
};

ActionsRow.propTypes = propTypes;

const mapStateToProps = createStructuredSelector({
  currentStep: selectRegistrationCurrentStep(),
});

export default withStyles(styles)(connect(mapStateToProps)(ActionsRow));
